import { Action } from 'redux'
import * as Actions from './actionTypes'
import { User } from 'src/common/models/user'
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions'
import { UserRole } from 'src/common/models/userRole'
import { UpdatePasswordRequest } from './types'
import { GenericUpdateResult } from 'src/common/state/types'

export interface GetUsersAction extends Action {
}
export interface GetUsersSuccessAction extends Action {
    users: User[]
}
export const getUsersApi = (): GetUsersAction => ({
    type: Actions.GET_USERS_API
})
export const getUsersApiSuccess = (users: User[]): GetUsersSuccessAction => ({
    type: Actions.GET_USERS_API_SUCCESS,
    users
})
export const getUsersApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_USERS_API_ERROR,
    error,
)

export interface UpsertUserAction extends Action {
    user: User
}
export interface UpsertUserSuccessAction extends Action {
    user: User
}
export const upsertUserApi = (user: User): UpsertUserAction => ({
    type: Actions.UPSERT_USER_API,
    user
})
export const upsertUserApiSuccess = (user: User): UpsertUserSuccessAction => ({
    type: Actions.UPSERT_USER_API_SUCCESS,
    user,
})
export const upsertUserApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPSERT_USER_API_ERROR,
    error,
)

export interface GetUserRolesAction extends Action {
}
export interface GetUserRolesSuccessAction extends Action {
    userRoles: UserRole[]
}
export const getUserRolesApi = (): GetUserRolesAction => ({
    type: Actions.GET_USER_ROLES_API
})
export const getUserRolesApiSuccess = (userRoles: UserRole[]): GetUserRolesSuccessAction => ({
    type: Actions.GET_USER_ROLES_API_SUCCESS,
    userRoles,
})
export const getUserRolesApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_USER_ROLES_API_ERROR,
    error,
)

export interface GetUserByIdAction extends Action {
    userId: number
}
export interface GetUserByIdSuccessAction extends Action {
    user: User
}
export const getUserByIdApi = (userId: number): GetUserByIdAction => ({
    type: Actions.GET_USER_BY_ID_API,
    userId,
})
export const getUserByIdApiSuccess = (user: User): GetUserByIdSuccessAction => ({
    type: Actions.GET_USER_BY_ID_API_SUCCESS,
    user,
})
export const getUserByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_USER_BY_ID_API_ERROR,
    error,
)

export interface UpdateUserPasswordAction extends Action {
    request: UpdatePasswordRequest
}
export interface UpdateUserPasswordSuccessAction extends Action {
    result: GenericUpdateResult
}
export const updateUserPasswordApi = (request: UpdatePasswordRequest): UpdateUserPasswordAction => ({
    type: Actions.UPDATE_USER_PASSWORD_API,
    request,
})
export const updateUserPasswordApiSuccess = (result: GenericUpdateResult): UpdateUserPasswordSuccessAction => ({
    type: Actions.UPDATE_USER_PASSWORD_API_SUCCESS,
    result,
})
export const updateUserPasswordApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPDATE_USER_PASSWORD_API_ERROR,
    error,
)

export const cleanCurrentUser = (): Action => ({
    type: Actions.CLEAN_CURRENT_USER,
});